const config = {
    API_BASE_URL: "https://your-upgrade.ru/api",
    //API_BASE_URL: "https://upgradeclubapp.ru/api",
    //API_BASE_URL: "http://localhost:8080/api",
};

export default config;
